import { useI18n } from 'vue-i18n';

// Formats membership level keys (e.g. ['plus', 'pro', 'gold']) as a localized
// disjunction list: "Plus, Pro, or Gold" in English, "Plus, Pro ou Gold" in
// French. Replaces the hand-rolled English serial-comma logic previously
// duplicated across the upgrade components.
export function useMembershipLevels() {
  const { t, locale } = useI18n();

  // Tolerates a missing/empty list (a member level with no upgrade path,
  // such as Gold) by returning '' instead of throwing.
  const formatMembershipLevels = (levels) => {
    if (!levels?.length) return '';

    return new Intl.ListFormat(locale.value, { style: 'long', type: 'disjunction' })
      .format(levels.map((level) => t(`membership.${level}`)));
  };

  return { formatMembershipLevels };
}
